import {
	DataTableCellAlphaNumeric,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import React from "react"
import { SummaryConfig } from "../SummaryTable.domain"
import { useGetLevelTranslate } from "components/Shared/Hooks/useGetLevelTranslate/useGetLevelTranslate"
import useFormaters from "components/Shared/Hooks/useFormatters"

interface SummaryTableRowProps {
	config: SummaryConfig
	currentRow: number
	tableData: [string, number][]
	isPoints?: boolean
}

const SummaryTableRow: React.FC<SummaryTableRowProps> = (props) => {
	const { config, currentRow, tableData, isPoints } = props
	const { formatNumber: number, formatPercentage: percentage } = useFormaters()
	return (
		<>
			<DataTableRow>
				<DataTableCellAlphaNumeric UNSAFE_className="data-table-description">
					{useGetLevelTranslate(config.firstColumn[currentRow])}
				</DataTableCellAlphaNumeric>

				{tableData.map(([key, value]) => {
					return (
						<DataTableCellAlphaNumeric key={key} UNSAFE_className="table-data">
							{isPoints
								? percentage(value, {
										decimals: 2,
										withPercentageChar: true,
								  })
								: number(value)}
						</DataTableCellAlphaNumeric>
					)
				})}
			</DataTableRow>
		</>
	)
}

export default SummaryTableRow
